import { Injectable, inject } from '@angular/core';
import { Either, Right } from 'purify-ts';
import { SessionSignalsStateService } from '../../application/session/session-store.service';
import { resetAuthInterceptorState } from '../../auth.interceptor';
import { SessionRepositoryFailure } from '../../domain/session/failure';
import { ISessionRepository } from '../../domain/session/i-session-repository';
import { SsoStart } from '../../domain/session/types';
import { IStorageRepository } from '../../domain/storage';

@Injectable({
  providedIn: 'root',
})
export class FakeSessionRepository implements ISessionRepository {
  private storage = inject(IStorageRepository);
  private sessionStore = inject(SessionSignalsStateService);

  public async signInWithSSO(): Promise<Either<SessionRepositoryFailure, SsoStart>> {
    await this.fakeSignIn();
    return Right({ providerUrl: '', verifierCode: 'fake-verifier' });
  }

  public async exchangeSSOToken(): Promise<Either<SessionRepositoryFailure, void>> {
    return this.fakeSignIn();
  }

  public async refreshToken(): Promise<Either<SessionRepositoryFailure, string>> {
    return Right('fake-token');
  }

  public async signOut(): Promise<Either<SessionRepositoryFailure, { url: string }>> {
    this.storage.clearAll();
    this.sessionStore.setState({ token: '', isLogged: false, userId: '' });
    return Right({ url: '/login' });
  }

  public async fakeSignIn(): Promise<Either<SessionRepositoryFailure, void>> {
    resetAuthInterceptorState();

    this.storage.setStorage('token', 'fake-token');
    this.storage.setStorage('refreshToken', 'fake-refresh-token');
    this.storage.setStorage('isLogged', true);
    this.storage.setStorage('userId', 'fake-user');

    this.sessionStore.setState({
      token: 'fake-token',
      isLogged: true,
      userId: 'fake-user',
    });

    return Right(undefined);
  }
}
